module.exports = __webpack_public_path__ + "img/meet_remain.5c6b7d52.png";